/**
 * Checkout error banner: message and dismiss button.
 * Presentational only; onDismiss is passed from parent.
 */
const CheckoutErrorBanner = ({ message, onDismiss }) => (
  <div className="flex items-center gap-3 bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded-lg mb-6 text-sm font-medium shadow-sm">
    <span className="text-base">!</span>
    <span>{message}</span>
    <button
      type="button"
      onClick={onDismiss}
      className="ml-auto bg-transparent border-0 text-lg text-red-700 cursor-pointer p-1 hover:text-red-900"
    >
      ×
    </button>
  </div>
);

export default CheckoutErrorBanner;
